<template>
  <div class="prontuario-medico-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Prontuario')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pet.prontuarioMedico"
            :is-restrict="$store.getters['pet/isRestrict']('prontuarioMedico')"
          >
            <template #value>
              <div v-if="pet.prontuarioMedico" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.medicalDocumentsURL + pet.prontuarioMedico
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Veterinario')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Nome')"
            :value="pet.nomeVeterinario | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('nomeVeterinario')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Telefone')"
            :value="pet.foneVeterinario"
            :is-restrict="$store.getters['pet/isRestrict']('foneVeterinario')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Clinica')"
            :value="pet.empresaVeterinario | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['pet/isRestrict']('empresaVeterinario')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Observacao')"
            :value="pet.observacao | capitalize({ onlyFirstLetter: true })"
            :is-restrict="$store.getters['pet/isRestrict']('observacao')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Prontuario_Medico") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Prontuario_Medico"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
};
</script>

<style scoped></style>
